//--------------- IMPORTAÇÕES ---------------//
import { useContext, useEffect } from "react";
import { X } from "lucide-react";
import { LeadsContext } from "../../context/LeadsContext";
import { addTagsBulkService, loadLeadsService, loadTagsService } from "../../services";



//------=--------- EXPORTAÇÕES ---------------//
export default function ModalAddTagsBulk() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const { isOpenModalAddTagsBulk, setIsOpenModalAddTagsBulk } = useContext(LeadsContext);
  const { tagsAvailable, setTagsAvailable } = useContext(LeadsContext);
  const { tagSearched, setTagSearched } = useContext(LeadsContext);
  const { tagsSelected, setTagsSelected } = useContext(LeadsContext);
  const { leads, setLeads } = useContext(LeadsContext);
  const { statusFilter, setStatusFilter } = useContext(LeadsContext);
  const { tagFilter, setTagFilter } = useContext(LeadsContext);
  const { total, setTotal } = useContext(LeadsContext);
  const { itemsPerPage, setItemsPerPage } = useContext(LeadsContext);
  const { currentPage, setCurrentPage } = useContext(LeadsContext);
  const { integrationsFilter, setIntegrationsFilter } = useContext(LeadsContext);



  //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
  useEffect(() => {

    handleLoadTags();

  }, [isOpenModalAddTagsBulk]);



  //------------ FUNÇÃO ASSÍNCRONA HANDLE REFRESH LEADS ------------//
  // Responsável por atualizar as leads via API
  // É utilizada a cada mudança nos hooks "currentPage", "itemsPerPage", "filterStatus" e "filterTag"
  // Armazena as leads no Estado "leads"
  // Armazena o total no Estado "total"
  async function handleRefreshLeads() {
    const offset = (currentPage - 1) * itemsPerPage;
    const term = "";
    const response = await loadLeadsService(itemsPerPage, offset, term, statusFilter, tagFilter, integrationsFilter);
    if (response) {
      setLeads(response.data.leads);
      setTotal(response.data.total);
    }
  };



  //------------------ FUNÇÃO ASSÍNCRONA HANDLE LOAD TAGS ------------------//
  // Responsável por carregar as Tags do Banco de Dados via API
  // Armazena a lista de tags disponíveis no Estado "TagsDisponiveis"
  async function handleLoadTags() {
    const response = await loadTagsService();
    if (response) {
      setTagsAvailable(response.data);
      setTagsSelected([]);
      setTagSearched("");
    }
  };



  //------------------ FUNLÃO ADD TAG ------------------//
  const hadleAddTag = (tag) => {
    if (!tagsSelected.includes(tag)) {
      setTagsSelected([...tagsSelected, tag]);
    }
    setTagSearched("");
  };



  //------------------ FUNÇÃO CREATE TAG ------------------//
  const handleCreateTag = () => {
    const newTag = tagSearched.trim();
    if (newTag && !tagsSelected.includes(newTag)) {
      setTagsSelected([...tagsSelected, newTag]);
      setTagSearched("");
    }

  };



  //------------------ FUNÇÃO REMOVE TAG ------------------//
  const handleRemoveTag = (tag) => {
    setTagsSelected(tagsSelected.filter((t) => t !== tag));
  };



  //------------------ FUNÇÃO ASSÍNCRONA HANDLE ADD TAGS BULK ------------------//
  const handleAddTagsBulk = async (tags) => {
    const response = await addTagsBulkService(tags)
    if (response) {
      setIsOpenModalAddTagsBulk(false);
      handleRefreshLeads();
    }
  };



  //------------------ RETORNO CONDICIONAL DO MODAL ADD TAGS BULK ------------------//
  return (
    <>
      {!isOpenModalAddTagsBulk
        ? null
        :
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 w-full max-w-md">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Adicionar tags aos leads</h2>
                <button onClick={() => { setIsOpenModalAddTagsBulk(false) }}><X className="text-white" /></button>
              </div>

              <label className="text-sm mb-1 block">Tag(s) para adicionar</label>
              <div className="flex items-center gap-2 mb-2">
                <input
                  type="text"
                  value={tagSearched}
                  onChange={(e) => setTagSearched(e.target.value)}
                  placeholder="Digite para buscar ou criar tag"
                  className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08] w-full"
                />
                <button onClick={handleCreateTag} className="px-3 py-2 bg-brand-600 hover:bg-brand-700 rounded text-sm">+</button>
              </div>

              <div className="mb-2 max-h-32 overflow-y-auto">
                {tagsAvailable.filter(tag => tag.nome.toLowerCase().includes(tagSearched.toLowerCase())).map(tag => (
                  <button
                    key={tag.id}
                    onClick={() => hadleAddTag(tag.nome)}
                    className="bg-surface-2 hover:bg-brand-600 text-white text-xs px-2 py-1 rounded mr-2 mb-1"
                  >
                    {tag.nome}
                  </button>
                ))}
              </div>

              <div className="flex gap-2 flex-wrap mb-4">
                {tagsSelected.map(tag => (
                  <div key={tag} className="bg-brand-600 px-2 py-1 rounded text-xs flex items-center gap-1">
                    {tag}
                    <button onClick={() => handleRemoveTag(tag)} className="text-white text-xs">×</button>
                  </div>
                ))}
              </div>

              <div className="text-right">
                <button
                  onClick={() => {
                    handleAddTagsBulk(tagsSelected);
                  }}
                  className="px-4 py-2 bg-brand-600 hover:bg-brand-700 rounded"
                >
                  + Adicionar Tags
                </button>
              </div>
            </div>
          </div>
        </>
      }
    </>
  )
}